import { render } from "./OrderTimeline.vue?vue&type=template&id=0483acc0&ts=true"
import script from "./OrderTimeline.vue?vue&type=script&lang=ts"
export * from "./OrderTimeline.vue?vue&type=script&lang=ts"

import "./OrderTimeline.vue?vue&type=style&index=0&id=0483acc0&lang=scss&scope=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__